import type { Meta, StoryFn } from '@storybook/react';
import type { ExpandableInfoPanelProps } from './ExpandableInfoPanel';

import { ExpandableInfoPanel } from './ExpandableInfoPanel';

import { Repeater } from 'components/Repeater';

const codeString =
  '<ExpandableInfoPanel triggerLabel={string} mainHeader={string or reactnode} collapseLabel={string} expandLabel={string} content={string or reactnode} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/ExpandableInfoPanel',
  component: ExpandableInfoPanel,
  parameters: {
    inspectComponent: ExpandableInfoPanel,
    codeString: codeString,
  },
} as Meta<ExpandableInfoPanelProps>;

const Template: StoryFn<ExpandableInfoPanelProps> = (args) => (
  <>
    <ExpandableInfoPanel {...args} />
    <div style={{ marginTop: '1rem' }}>
      De universiteit biedt een breed scala aan vakken aan, variërend van exacte wetenschappen tot geesteswetenschappen.
      Studenten kunnen kiezen uit uitdagende keuzevakken, minors en specialisaties die hun studie verrijken. Deze
      vaklaanbiedingen stimuleren interdisciplinair leren, persoonlijke ontwikkeling en academische verdieping,
      afgestemd op actuele maatschappelijke vraagstukken en de behoeften van de arbeidsmarkt.
    </div>
  </>
);

export const ExpandableInfoPanelExample = Template.bind({});
ExpandableInfoPanelExample.args = {
  triggerLabel: 'Wat moet ik doen?',
  mainHeader: <h1>Basisgegevens</h1>,
  collapseLabel: 'Sluit informatiepaneel',
  expandLabel: 'Open informatiepaneel',
  content: (
    <>
      <h3 style={{ marginTop: '0' }}>Wat moet ik doen?</h3>
      <span>
        Controleer de onderstaande basisgegevens. Klik daarna op ‘Start’ om te beginnen met het invoeren van de
        roosterwensen. Je kunt tussentijds opslaan en op een later moment verdergaan.
      </span>
      <br />
      <br />
      <span>Kloppen de gegevens niet? Neem contact op met de opleidingscoördinator.</span>
    </>
  ),
};

export const DefaultOpenWithNote = Template.bind({});
DefaultOpenWithNote.args = {
  triggerLabel: 'Wat moet ik doen?',
  mainHeader: <h1>Basisgegevens</h1>,
  collapseLabel: 'Sluit informatiepaneel',
  expandLabel: 'Open informatiepaneel',
  content: (
    <>
      <h3 style={{ marginTop: '0' }}>Wat moet ik doen?</h3>
      <span>
        Controleer de onderstaande basisgegevens. Klik daarna op ‘Start’ om te beginnen met het invoeren van de
        roosterwensen. Je kunt tussentijds opslaan en op een later moment verdergaan.
      </span>
      <br />
      <br />
      <span>Kloppen de gegevens niet? Neem contact op met de opleidingscoördinator.</span>
    </>
  ),
  note: (
    <Repeater gap="050">
      <span style={{ fontWeight: '700' }}>Let op</span>
      <span>hier kunt u een extra opmerking achterlaten om de inhoud van uw gewone paneel te versterken.</span>
    </Repeater>
  ),
  defaultOpen: true,
};
